import { ROLES } from "app/constants";
import useAccess from "features/profile/useAccess";
import { useEffect, useState } from "react";
import { getWebCommentCount } from "./bookingApi";

export default function useWebCommentCount() {
  const [count, setCount] = useState(0);
  const { hasRoles } = useAccess();

  async function loadCount() {
    if (hasRoles(ROLES.PARTNER)) {
      return;
    }
    const { success, data } = await getWebCommentCount();
    if (success) {
      setCount(data?.count || 0);
    }
  }

  useEffect(() => {
    loadCount();
  }, []);

  return count;
}
